import { ptBR } from "date-fns/locale";

/**
 * Returns the date-fns locale. App is Portuguese-only, so always pt-BR.
 */
export const useDateFnsLocale = () => ptBR;
